import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { AI360_DETAILS_PAGE_ROUTE } from 'src/Libs/ai-360/consts'
import { HomePage, DetailsPageContainer } from 'src/Libs/ai-360/pages'
import { isFlowTheme } from 'src/Libs/utils/theme-helpers'

const AI360Route: React.FC = () => {
  if (isFlowTheme) return <Navigate to="/" />

  return (
    <Routes>
      <Route path={`/${AI360_DETAILS_PAGE_ROUTE}`} element={<DetailsPageContainer />} />
      <Route path={`/`} element={<HomePage />} />
    </Routes>
  )
}

export default AI360Route
